import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import APP_CONST from "../../../shared/constants";
import { getRecordStatus } from "../../../../../utils/utilsHelper";

const DocumentStatus = (
  iconList,
  propsList,
  onDownloadIconClick,
  setIsDocViewVisible,
  documentDetailsHandler,
  deletePopup
) => {
  const { t } = useTranslation();
  const {AGGRID_FIELD, VIEDOC_ICON} = APP_CONST

  const { downLoader, downloadingFiles } = useSelector((store) => store.file);
  const { isDeleting, deletingDocuments } = useSelector(
    (store) => store.document
  );

  const ActionList = (icon, propsList) => {
    switch (icon) {
      case "download":
        onDownloadIconClick(propsList.data, false, true);
        return;
      case "visibility":
        setIsDocViewVisible(true);
        documentDetailsHandler(propsList.data);
        return;
      case "delete_outlined":
        deletePopup(propsList.data);
        return;

      default:
        return;
    }
  };

  const checkLockStatus = (item, propsList) => {
    if (
      !propsList.data.status &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_PREVIEW &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_AGACTION &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_DELACTION
    )
      return VIEDOC_ICON.ICON_DUMMY_LOCK;
    if (item === VIEDOC_ICON.ICON_LOCK) {
      if (propsList.data.islocked) {
        return item;
      }
      return VIEDOC_ICON.ICON_DUMMY_LOCK;
    } else if (
      propsList.data.status === APP_CONST.TEXT_FLAGGEDBYQC &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_PREVIEW &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_AGACTION &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_DELACTION
    ) {
      return VIEDOC_ICON.ICON_FLAG;
    } else if (
      propsList.data.status === APP_CONST.TEXT_AWAITINGREVIEW &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_PREVIEW &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_AGACTION &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_DELACTION
    ) {
      return VIEDOC_ICON.ICON_LOAD;
    } else if (
      propsList.data.status === APP_CONST.TEXT_UNPUBLISHED &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_PREVIEW &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_AGACTION &&
      propsList.colDef.field !== AGGRID_FIELD.TEXT_DELACTION
    ) {
      return VIEDOC_ICON.ICON_BLOCK;
    } else {
      return item;
    }
  };

  const generateTitle = (item, propsList) => {
    if (propsList.colDef.field === APP_CONST.TEXT_STATUS) {
      if (item === APP_CONST.VIEDOC_ICON.ICON_LOCK)
        return propsList.data.islocked ? t("ADMIN.TEXT_LOCKED") : "";
      else return getRecordStatus(propsList.data.status);
    } else {
      switch (item) {
        case APP_CONST.VIEDOC_ICON.ICON_DELETE_OUTLINE:
          return t("TMF.TEXT_DELETE");
        case APP_CONST.VIEDOC_ICON.ICON_VISBILITY:
          return t("TMF.TEXT_PREVIEW");
        case APP_CONST.VIEDOC_ICON.ICON_DOWNLOAD:
          return t("TMF.TEXT_DOWNLOAD");
        case APP_CONST.VIEDOC_ICON.ICON_VISIBILITY_OFF:
          return t("TMF.TEXT_PREVIEWNOTALLOW");
      }
    }
  };

  const generateIconList = (item, propsList, index) => {
    return (
      <div
        key={index}
        className="icon-container"
        onClick={() => {
          ActionList(item, propsList);
        }}
      >
        {(downLoader &&
          item === "download" &&
          downloadingFiles.includes(propsList.data.documentguid)) ||
        (isDeleting &&
          item === "delete_outlined" &&
          (deletingDocuments.includes(propsList.data.documentid) ||
            deletingDocuments.includes(propsList.data.tmfdropzoneid))) ? (
          <viedoc-spinner />
        ) : (
          <viedoc-icon
            name={checkLockStatus(item, propsList)}
            class={item.includes("visibility_off") ? "icon-grey" : "icon-black"}
            title={generateTitle(item, propsList)}
          />
        )}
      </div>
    );
  };
  const checkIconStatus = (item, propsList) => {
    switch (item) {
      case VIEDOC_ICON.ICON_DELETE_OUTLINE:
        if (propsList.data.status === APP_CONST.TEXT_UNPUBLISHED || !propsList.data.status) {
          return true;
        }
        return false;
      default:
        return true;
    }
  };
  return (
    <div className="icon-list">
      {iconList.map((item, index) => (
        <Fragment key={index}>
          {checkIconStatus(item, propsList) ? (
            generateIconList(item, propsList, index)
          ) : (
            <div className="icon-container">
              {isDeleting &&
              (deletingDocuments.includes(propsList.data.documentid) ||
                deletingDocuments.includes(propsList.data.tmfdropzoneid)) ? (
                <viedoc-spinner />
              ) : (
                ""
              )}
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default DocumentStatus;
